import React, { useState, useEffect } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import Config from "../../config/env";
import API from "../../utils/apiCalling";
import Loader from "../../utils/loader";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const BataExcelReport = () => {
  const [dashboardData, setDashboardData] = useState([]);
  const [allQuestions, setAllQuestions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [surveyId, setSurveyId] = useState(null);
  const checkarray = ["Select Stores"];
  const id = useParams();

  let api = new API();

  useEffect(() => {
    getSurveyById(id);
    getDashBoard(id);
  }, []);

  const getSurveyById = async (id) => {
    let data = { id: id.id };
    let result = await api.post(
      `${Config.new.site_api}/client-survey/getSurvey`,
      data
    );

    if (result && result.code === 200) {
      const questionsWithState = result.data.questions.map((q) => ({
        ...q,
        isOpen: false,
      }));
      setAllQuestions(questionsWithState);
    }
  };

  const getDashBoard = async (surveyId) => {
    try {
      setLoader(true);

      // Prepare the API request payload
      const data = { surveyId: surveyId.id };

      // Make the API call
      const surveyData = await api.post(
        `${Config.new.site_api}/client-survey/Dashboard`,
        data
      );
      console.log("API Response:", surveyData);

      // Validate the API response
      if (surveyData?.code === 200 && Array.isArray(surveyData.data)) {
        const cutoffDate = new Date("2024-11-22T00:00:00.000Z"); // Set cutoff date

        // Filter objects based on the date
        const filteredData = surveyData.data.filter((item) => {
          // Validate that item.date exists and is a valid date
          if (item?.date) {
            const itemDate = new Date(item.date); // Convert to Date object
            if (!isNaN(itemDate)) {
              return itemDate > cutoffDate; // Compare dates
            } else {
              console.warn(`Invalid date format for item:`, item);
              return false; // Exclude invalid date formats
            }
          } else {
            console.warn(`Missing date field in item:`, item);
            return false; // Exclude items without a date field
          }
        });

        // Log filtered data for debugging
        console.log("Filtered Data:", filteredData);

        // Update the state with the filtered data
        setDashboardData(filteredData);
      } else {
        console.error(
          "Unexpected response structure or error in API:",
          surveyData
        );
      }
    } catch (error) {
      console.error("Error in getDashBoard:", error); // Handle unexpected errors
    } finally {
      setLoader(false); // Ensure the loader is turned off
    }
  };
  // Helper function to check if the question is in the checkarray
  const isQuestionInCheckArray = (question) => {
    return checkarray.includes(question);
  };
  const handleDownload = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    worksheet.getColumn(1).width = 10;
    worksheet.getColumn(2).width = 20;
    worksheet.getColumn(3).width = 45;
    worksheet.getColumn(4).width = 10;
    worksheet.getColumn(5).width = 10;
    // Merge cells for headers
    worksheet.mergeCells("A2:A2");
    worksheet.mergeCells("A3:A3");
    worksheet.mergeCells("A4:A4");
    worksheet.mergeCells("A5:A5");
    worksheet.mergeCells("A6:A6");
    worksheet.mergeCells("A7:A7");
    worksheet.mergeCells("A8:A8");
    worksheet.mergeCells("A9:A9");
    worksheet.mergeCells("A10:A10");
    worksheet.mergeCells("A11:A11");
    worksheet.mergeCells("A12:A12");
    worksheet.mergeCells("A13:A13");
    worksheet.mergeCells("A14:A14");
    worksheet.mergeCells("A15:A15");

    worksheet.mergeCells("B2:B2");
    worksheet.mergeCells("B3:B3");
    worksheet.mergeCells("B4:B4");
    worksheet.mergeCells("B5:B5");
    worksheet.mergeCells("B6:B6");
    worksheet.mergeCells("B7:B7");
    worksheet.mergeCells("B8:B8");
    worksheet.mergeCells("B9:B9");
    worksheet.mergeCells("B10:B10");
    worksheet.mergeCells("B11:B11");
    worksheet.mergeCells("B12:B12");
    worksheet.mergeCells("B13:B13");
    worksheet.mergeCells("B14:B14");
    worksheet.mergeCells("B15:C15");

    worksheet.mergeCells("C2:C2");
    worksheet.mergeCells("C3:C3");
    worksheet.mergeCells("C4:C4");
    worksheet.mergeCells("C5:C5");
    worksheet.mergeCells("C6:C6");
    worksheet.mergeCells("C7:C7");
    worksheet.mergeCells("C8:C8");
    worksheet.mergeCells("C9:C9");
    worksheet.mergeCells("C10:C10");
    worksheet.mergeCells("C11:C11");
    worksheet.mergeCells("C12:C12");
    worksheet.mergeCells("C13:C13");
    worksheet.mergeCells("C14:C14");
    // worksheet.mergeCells('C15:C15');

    worksheet.mergeCells("D2:D2");
    worksheet.mergeCells("D3:D3");
    worksheet.mergeCells("D4:D4");
    worksheet.mergeCells("D5:D5");
    worksheet.mergeCells("D6:D6");
    worksheet.mergeCells("D7:D7");
    worksheet.mergeCells("D8:D8");
    worksheet.mergeCells("D9:D9");
    worksheet.mergeCells("D10:D10");
    worksheet.mergeCells("D11:D11");
    worksheet.mergeCells("D12:D12");
    worksheet.mergeCells("D13:D13");
    worksheet.mergeCells("D14:D14");
    worksheet.mergeCells("D15:D15");

    worksheet.mergeCells("E2:E2");
    worksheet.mergeCells("E3:E3");
    worksheet.mergeCells("E4:E4");
    worksheet.mergeCells("E5:E5");
    worksheet.mergeCells("E6:E6");
    worksheet.mergeCells("E7:E7");
    worksheet.mergeCells("E8:E8");
    worksheet.mergeCells("E9:E9");
    worksheet.mergeCells("E10:E10");
    worksheet.mergeCells("E11:E11");
    worksheet.mergeCells("E12:E12");
    worksheet.mergeCells("E13:E13");
    worksheet.mergeCells("E14:E14");
    worksheet.mergeCells("E15:E15");

    worksheet.mergeCells("F2:F2");
    worksheet.mergeCells("F3:F3");
    worksheet.mergeCells("F4:F4");
    worksheet.mergeCells("F5:F5");
    worksheet.mergeCells("F6:F6");
    worksheet.mergeCells("F7:F7");
    worksheet.mergeCells("F8:F8");
    worksheet.mergeCells("F9:F9");
    worksheet.mergeCells("F10:F10");
    worksheet.mergeCells("F11:F11");
    worksheet.mergeCells("F12:F12");
    worksheet.mergeCells("F13:F13");
    worksheet.mergeCells("F14:F14");
    worksheet.mergeCells("F15:F15");
    // Merge cells for new headers

    // Define styles
    const headerStyle = {
      font: { bold: true, color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "dededd" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };

    const plannedstyle = {
      font: { bold: false, color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "bdd3f9" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const cellStyle = {
      font: { bold: false, color: { argb: "00000000" } },
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFFFFFFF" },
      },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const plannedcellstyle = {
      font: { bold: false, color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "dfebf7" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const achievedstyle = {
      font: { color: { argb: "00000000" }, size: 12 },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "92c67c" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const achievedcellstyle = {
      font: { bold: false, color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "ddf9d6" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const pendingtyle = {
      font: { color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "fe9c9c" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };
    const pendingcellstyle = {
      font: { bold: false, color: { argb: "00000000" } },
      fill: { type: "pattern", pattern: "solid", fgColor: { argb: "ffe6e6" } },
      alignment: { horizontal: "center", vertical: "middle" },
      border: {
        top: { style: "thin", color: { argb: "FF000000" } },
        left: { style: "thin", color: { argb: "FF000000" } },
        bottom: { style: "thin", color: { argb: "FF000000" } },
        right: { style: "thin", color: { argb: "FF000000" } },
      },
    };

    // Define cell values and styles for column A
    const cellsToStyleA = [
      { cell: "A2", value: "S.No." },
      { cell: "A3", value: "1" },
      { cell: "A4", value: "2" },
      { cell: "A5", value: "3" },
      { cell: "A6", value: "4" },
      { cell: "A7", value: "5" },
      { cell: "A8", value: "6" },
      { cell: "A9", value: "7" },
      { cell: "A10", value: "8" },
      { cell: "A11", value: "9" },
      { cell: "A12", value: "10" },
      { cell: "A13", value: "11" },
      { cell: "A14", value: "12" },
      { cell: "A15", value: "13" },
    ];

    cellsToStyleA.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "S.No.") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });

    // Define cell values and styles for column B
    const cellsToStyleB = [
      { cell: "B2", value: "Stores" },
      { cell: "B3", value: "Airia Gurgaon" },
      { cell: "B4", value: "Ardee Mall" },
      { cell: "B5", value: "Dt Mega Mall" },
      { cell: "B6", value: "Good Earth City" },
      { cell: "B7", value: "Gurgaon Sec 17" },
      { cell: "B8", value: "Mgf Mall" },
      { cell: "B9", value: "DLF Mall of India" },
      { cell: "B10", value: "Logix Mall" },
      { cell: "B11", value: "NSP Pitampura" },
      { cell: "B12", value: "GURGAON SEC 31" },
      { cell: "B13", value: "SEC-46 GURGAON" },
      { cell: "B14", value: "Pacific Khayal" },
      { cell: "B15", value: "Total" },
    ];

    cellsToStyleB.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Stores" || value=="Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });

    // Define cell values and styles for column C
    const cellsToStyleC = [
      { cell: "C2", value: "Category" },
      { cell: "C3", value: "ZBM" },
      { cell: "C4", value: "ZBM" },
      { cell: "C5", value: "ZBM" },
      { cell: "C6", value: "ZBM" },
      { cell: "C7", value: "ZBM" },
      { cell: "C8", value: "ZBM" },
      { cell: "C9", value: "Non ZBM" },
      { cell: "C10", value: "Non ZBM" },
      { cell: "C11", value: "Non ZBM" },
      { cell: "C12", value: "Non ZBM" },
      { cell: "C13", value: "Non ZBM" },
      { cell: "C14", value: "Non ZBM" },
      // { cell: 'C15', value: '' },
    ];

    let data = ["Category"];

    cellsToStyleC.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (value == "Category") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == "Total") {
        excelCell.font = headerStyle.font;
        excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = cellStyle.fill;
      }
    });

    // Define cell values and styles for new headers
    const cellsToStyleNew = [
      { cell: "D2", value: "Planned" },
      { cell: "E2", value: "Achieved" },
      { cell: "F2", value: "Pending" },
    ];
    let data2 = ["Total"];
    cellsToStyleNew.forEach(({ cell, value }) => {
      const excelCell = worksheet.getCell(cell);
      excelCell.value = value;
      if (data2.includes(value)) {
        excelCell.font = headerStyle.font;
        excelCell.fill = cellStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == "Planned") {
        excelCell.font = headerStyle.font;
        excelCell.fill = plannedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == "Achieved") {
        excelCell.font = headerStyle.font;
        excelCell.fill = achievedstyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else if (value == "Pending") {
        excelCell.font = headerStyle.font;
        excelCell.fill = pendingtyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
      } else {
        // excelCell.fill = headerStyle.fill;
        excelCell.alignment = headerStyle.alignment;
        excelCell.border = headerStyle.border;
        excelCell.fill = headerStyle.fill;
        excelCell.font = headerStyle.font;
      }
    });
    let columnDValues = [];
    // Define the values to fill in column D
    if (id?.id == "6757ca206787a1fdebc3e0e9") {
      columnDValues = [25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 25, 300];
    }

    // Fill values in column D only if the corresponding cell in column C is not empty
    let valueIndex = 0;
    for (let rowIndex = 3; rowIndex <= worksheet.rowCount; rowIndex++) {
      const cellC = worksheet.getCell(`C${rowIndex}`);
      if (cellC.value) {
        const cellD = worksheet.getCell(`D${rowIndex}`);
        cellD.value = columnDValues[valueIndex++];
        if (rowIndex == 15) {
          cellD.font = headerStyle.font;
          cellD.fill = cellStyle.fill;
        } else {
          cellD.font = cellStyle.font;

          cellD.fill = pendingcellstyle.fill;
        }
        cellD.alignment = cellStyle.alignment;
        cellD.border = cellStyle.border;
      }
    }

    // Define the values to fill in column G

    // ---------Delhi-------------
    // Define criteria for "Achieved" columns
    const criteriaMap = {
      // 3: ['Delhi', 'Organized sector - you or your firm/ company is registered', 'Self-Employed Professional/Businessman/Freelancer'],
      3: ["Airia Gurgaon"],
      4: ["Ardee Mall"],
      5: ["Dt Mega Mall"],
      6: ["Good Earth Cty"],
      7: ["Gurgaon Sec 17"],
      8: ["Mgf Mall"],
      9: ["DLF Mall of India"],
      10: ["Logix Mall"],
      11: ["NSP Pitampura"],
      12: ["GURGAON SEC 31"],
      13: ["SEC-46 GURGAON"],
      14: ["Pacific Khayal"],
    };

    // Helper function to check if a criterion is met
    const isCriterionMet = (answer, criterion) => {
      if (Array.isArray(criterion)) {
        return criterion.some((crit) =>
          Array.isArray(answer) ? answer.includes(crit) : answer === crit
        );
      } else {
        if (Array.isArray(answer)) {
          return (
            answer.includes(criterion) ||
            (criterion === "Rs. 10-15 lakh per annum" &&
              answer.includes("More than Rs. 15 lakh per annum")) ||
            (criterion === "Other" &&
              answer.some((ans) => ans.includes("Other:")))
          );
        } else {
          return (
            answer === criterion ||
            (criterion === "Rs. 10-15 lakh per annum" &&
              answer === "More than Rs. 15 lakh per annum") ||
            (criterion === "Other" && answer?.includes("Other:"))
          );
        }
      }
    };

    // Count matches and fill values in "Achieved" column
    const countMatches = (criteria) => {
      return dashboardData.filter((response) =>
        criteria.every((criterion) =>
          Array.isArray(criterion)
            ? criterion.some((subCriterion) =>
                response.questions.some(
                  (q) =>
                    isQuestionInCheckArray(q.question) &&
                    isCriterionMet(q.answer, subCriterion)
                )
              )
            : response.questions.some(
                (q) =>
                  isQuestionInCheckArray(q.question) &&
                  isCriterionMet(q.answer, criterion)
              )
        )
      ).length;
    };

    Object.keys(criteriaMap).forEach((rowIndex) => {
      const criteria = criteriaMap[rowIndex];
      const count = countMatches(criteria);
      const cellH = worksheet.getCell(`E${rowIndex}`);
      cellH.value = count;
      if (rowIndex == 15) {
        cellH.font = headerStyle.font;
        cellH.fill = cellStyle.fill;
      } else {
        cellH.font = cellStyle.font;

        cellH.fill = pendingcellstyle.fill;
      }
      cellH.alignment = cellStyle.alignment;
      cellH.border = cellStyle.border;
    });

    // Calculate the sum of E3 to E14
    let sumE = 0;
    for (let rowIndex = 3; rowIndex <= 14; rowIndex++) {
      const cellE = worksheet.getCell(`E${rowIndex}`);
      sumE += cellE.value || 0; // Add the cell value, default to 0 if empty or undefined
    }

    // Set the sum value in E15
    const cellE15 = worksheet.getCell("E15");
    cellE15.value = sumE;
    cellE15.font = headerStyle.font; // Apply bold style for the sum
    cellE15.fill = achievedcellstyle.fill;
    cellE15.alignment = cellStyle.alignment;
    cellE15.border = cellStyle.border;

    const columnsFinal = [{ result: "F", from: "D", subtract: "E" }];

    columnsFinal.forEach(({ result, from, subtract }) => {
      for (let rowIndex = 3; rowIndex <= worksheet.rowCount; rowIndex++) {
        const cellC = worksheet.getCell(`B${rowIndex}`);
        if (cellC.value) {
          const cellFrom = worksheet.getCell(`${from}${rowIndex}`);
          const cellSubtract = worksheet.getCell(`${subtract}${rowIndex}`);
          const cellToFill = worksheet.getCell(`${result}${rowIndex}`);
          const valueFrom = cellFrom.value || 0;
          const valueSubtract = cellSubtract.value || 0;
          cellToFill.value = valueFrom - valueSubtract;
          if (rowIndex == 15) {
            cellToFill.font = headerStyle.font;
            cellToFill.fill = cellStyle.fill;
          } else {
            cellToFill.font = cellStyle.font;

            cellToFill.fill = pendingcellstyle.fill;
          }
          cellToFill.alignment = cellStyle.alignment;
          cellToFill.border = cellStyle.border;
        }
      }
    });

    // -------total Values --------

    //  Sum the values of the specified columns for each row and fill in column E

    if (id?.id == "6757ca206787a1fdebc3e0e9") {
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], { type: "application/octet-stream" });
      saveAs(blob, "BataQccReport.xlsx");
      setLoader(false);
    }
  };

  return (
    <>
      {loader && <Loader />}
      {/* <h1> Bata</h1> */}
      <div className="excelcontainer">
        <div className="excelcard">
          {id?.id == "6757ca206787a1fdebc3e0e9" && (
            <>
              {" "}
              <label>Bata Survey Report</label>
              <button
                className="btn btn-primary"
                onClick={() => handleDownload()}
              >
                Download
              </button>
            </>
          )}
          <br />
        </div>
      </div>
    </>
  );
};

export default BataExcelReport;
